export const GET_LOOKUP_CODE_TYPES = "GET_LOOKUP_CODE_TYPES"


// WEBPACK FOOTER //
// ./src/actionTypes/lookupCodeType.js